import React from 'react';
import PropTypes from 'prop-types';
import Text from '../../ui/Text';
import styles from './Tabs.module.scss';

export default function Tabs({ setActiveTab, activeTab, tabs }) {
  const selectableTabs = tabs.filter(tab => !tab.divider);

  const calculateNextTab = (nextPosition) => {
    const lastTabIndex = selectableTabs.length - 1;

    if (nextPosition > lastTabIndex) return selectableTabs[0];
    if (nextPosition < 0) return selectableTabs[lastTabIndex];

    return selectableTabs[nextPosition];
  };

  const handleNextTab = (nextPosition) => {
    const nextTab = calculateNextTab(nextPosition);
    const nextTabObject = document.getElementById(`tab-${nextTab.key}`);

    setActiveTab(nextTab.key);
    nextTabObject.focus();
  };

  const handleKeyPress = (event) => {
    const currentPosition = selectableTabs.map(tab => tab.key).indexOf(activeTab);

    if (event.key === 'Home') {
      const nextPosition = 0;
      handleNextTab(nextPosition);
    }

    if (event.key === 'End') {
      const nextPosition = selectableTabs.length - 1;
      handleNextTab(nextPosition);
    }

    if (event.key === 'ArrowUp') {
      const nextPosition = currentPosition - 1;
      handleNextTab(nextPosition);
    }

    if (event.key === 'ArrowDown') {
      const nextPosition = currentPosition + 1;
      handleNextTab(nextPosition);
    }
  };

  const renderTab = (tabKey, label) => (
    <button
      key={tabKey}
      aria-selected={activeTab === tabKey}
      className={`${styles.button} ${activeTab === tabKey ? styles.active : ''}`}
      id={`tab-${tabKey}`}
      role="tab"
      tabIndex={activeTab === tabKey ? 0 : -1}
      type="button"
      onClick={() => (setActiveTab(tabKey))}
      onKeyDown={handleKeyPress}
    >
      <Text weight={activeTab === tabKey ? 'semibold' : 'normal'}>
        {label}
      </Text>
    </button>
  );

  return (
    <div className={styles.tab_container}>
      {tabs.map(tab => (
        tab.divider ?
          <hr key={tab.key} className={styles.divider} /> :
          renderTab(tab.key, tab.label)
      ))}
    </div>
  );
}

Tabs.propTypes = {
  activeTab: PropTypes.string.isRequired,
  setActiveTab: PropTypes.func.isRequired,
  tabs: PropTypes.arrayOf(PropTypes.shape({
    divider: PropTypes.bool,
    key: PropTypes.string.isRequired,
    label: PropTypes.string,
  })).isRequired
};
